import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '@k12/app-services';
import { SchoolAuthService } from '../services/school-auth.service';

/**
 * Keeps users without an Approved school role off /rosters, which the menu alone does not do for a
 * typed or bookmarked URL. A denial is re-checked against a refreshed token first, so a school that
 * was approved after sign-in is not turned away on the strength of a stale Pending claim.
 */
export const rostersGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const schoolAuthService = inject(SchoolAuthService);
  const authService = inject(AuthService);
  const router = inject(Router);

  if (schoolAuthService.canAccessRosters) {
    return true;
  }

  await authService.forceRefresh();

  return schoolAuthService.canAccessRosters || router.createUrlTree(['/home']);
};
